import classNames from 'classnames';
import { generateCompStylers } from '../../../../../../../common/utils/styles';
import css from './PhoneButton.module.scss';
import ReactCountryFlag from 'react-country-flag';
import { svgSprite } from '../../../../../../../hybrid/wrappers';

const PhoneButton = ({ compStyle, phoneDropDown, selectedCountryData, disabled }) => {
    const { stylers, classes } = generateCompStylers(compStyle);
    return (
        <div
            onClick={(e) => {
                if (!disabled) {
                    e.stopPropagation();
                    phoneDropDown?.setOpenDropDown((pre) => !pre);
                }
            }}
            style={stylers.flagButton}
            className={classNames(
                !disabled ? css.pointer : '',
                css.formControlIconWrap,
                css.formControlPhoneBotton,
                classes.flag
            )}
        >
            <ReactCountryFlag
                svg
                countryCode={selectedCountryData?.country?.replace('-copy', '')}
                style={{
                    border: '1px solid var(--greyProductHoverColor)',
                    objectFit: 'cover',
                    width: '20px',
                    height: '14px',
                    ...stylers.flag
                }}
            />
            {disabled
                ? null
                : svgSprite(phoneDropDown?.isOpened ? 'angle-up' : 'angle-down', {
                      width: '8px',
                      height: '4px',
                      className: css.formControlPhoneBottonArrow
                  })}
        </div>
    );
};
export default PhoneButton;
